<template>
<div>
	
	<div class="fullscreen" v-if="car">

		<div class="head head-with-brand big">
			<div class="container">
				<div class="btn icon icon-close invert" @click="cancel"></div>
				<small>CHASSIS</small>
				<h1>{{car.chassis_number}}</h1>
				<h2>{{car.brand.title}} {{car.model}}</h2>
				<div class="brand" v-if="car.brand.logo" :style="{backgroundImage:`url(${API_URL+car.brand.logo.urlThumb})`}"></div>
			</div>
		</div>
		
		<div class="content" v-if="car">
			<div class="container">

				<div class="card mt-2">
					<div class="card-body">

						<table class="table table-borderless table-centered">
							<tr>
								<td>Tipo de vehículo</td><td>{{car.category.title}}</td>
							</tr>
							<tr>
								<td>Color</td><td>{{car.color.title}}</td>
							</tr>
							<tr>	
								<td>N Chasis</td><td>{{car.chassis_number}}</td>
							</tr>
							<tr>	
								<td>N Motor</td><td>{{car.motor_number}}</td>
							</tr>
							<tr>	
								<td>Ubicación</td><td>{{car.locationText}}</td>
							</tr>
							<tr>	
								<td colspan="2" class="text-center">
									<div class="car-status-point" :class="car.status"></div>{{car.statusText}}
								</td>
							</tr>
						</table>
					</div>
				</div>
				<div class="buttons mt-2 mb-4">
					<div @click="startControl('admission')" class="btn box-shadow mt-2 btn-outline-secondary" v-if="car.canAdmit">ADMISIÓN DE VEHICULO</div>
					<div @click="startControl('move')" class="btn box-shadow mt-2 btn-outline-secondary"  v-if="car.canMove">MOVER VEHICULO</div>
					<div @click="startControl('dispatch')" class="btn box-shadow mt-2 btn-outline-secondary"  v-if="car.canDispatch">DESPACHAR  VEHICULO</div>
					<div @click="startControl('pre-delivery')" class="btn box-shadow mt-2  btn-outline-secondary"  v-if="car.canPreDelivery">PRE ENTREGAR  VEHICULO</div>
					<div @click="startControl('delivery')" class="btn box-shadow mt-2 btn-outline-secondary"  v-if="car.canDelivery">ENTREGAR  VEHICULO A CLIENTE</div>					
					<div @click="startControl('transfer-out')" class="btn box-shadow mt-2 btn-outline-secondary"  v-if="car.canTransferIn">INICIAR TRASLADO</div>
					<div @click="startControl('transfer-in')" class="btn box-shadow mt-2 btn-outline-secondary" v-if="car.canTransferIn">FINALIZAR TRASLADO</div>
					<div @click="startControl('damages')" class="btn box-shadow mt-2 btn-outline-secondary" v-if="car.canMove">REGISTRAR DAÑO</div>
					<div @click="startControl('fuel-load')" class="btn box-shadow mt-2 btn-outline-secondary"  v-if="car.canFuelLoad">CARGAR COMBUSTIBLE</div>
				</div>
			</div>
		</div>
		
	</div>
</div>
</template>
	

<script>
import gql from 'graphql-tag'
import { mapState, mapMutations } from 'vuex'

export default {
	name: 'CarDetail',
	data () {
		return {
			API_URL: process.env.VUE_APP_API_URL,
			loading: true,
			car: null
		}
	},
	computed: {
		...mapState(['control'])
	},
	beforeMount(){
		this.load()
	},
	methods:{
		...mapMutations(['saveControl']),
		load(){
			this.loading = true
			this.$apollo.query({
				query: gql`query ($id: ID!) {
					car (id: $id) {
						id
						chassis_number
						motor_number
						dua_transit
						model
						brand{
							title
							logo{
								urlThumb
							}
						}
						color{
							title
						}
						category{
							title
							draw
						}
						status
						statusText
						locationText
						canAdmit
						canMove
						canFuelLoad
						canDispatch
						canPreDelivery
						canDelivery
						canTransferOut
						canTransferIn
					}
				}`,
				variables: {
					id: this.$route.params.carId,
				},
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				this.car = data.data.car
				this.loading = false
			})
		},
		cancel(){
			this.$router.push('/')
		},
		startControl(type){
			var control = {}
			control.type = type
			control.car = this.car
			control.step = 'main' 	// este siempre va a ser la pantalla principal del cntrol
			control.damages = []	
			control.missings = []
			control.charges = []

			this.saveControl(control)
			this.$router.push(`/control/${this.car.id}/${type}`)
		},

	}
}


</script>

<style scoped lang="scss">


.buttons{
	display: flex;
	flex-wrap: wrap;
	justify-content: center;

	.btn{
		margin: 2px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #fff;
		border:none;
		color: #000;
		width: 180px;
		height: 80px;
		flex-grow: 1;
	}
}

</style>
